import { Alpine } from '../../core/alpine-core.js';
import { apiFetch } from '../api.js';

function parseFixtureId() {
  const parts = location.pathname.split('/').filter(Boolean);
  const idx = parts.indexOf('fixtures');
  if (idx >= 0 && parts[idx + 1]) return decodeURIComponent(parts[idx + 1]);
  return null;
}

function routerNavigate(path) {
  const router = window.PineconeRouter;
  if (router?.navigate) router.navigate(path);
  else window.location.href = path;
}

Alpine.data('fixtureSummary', () => ({
  fixtureId: '',
  fixture: null,
  session: null,
  loading: true,
  error: '',

  async init() {
    this.fixtureId = parseFixtureId() || '';
    try {
      await this.loadFixture();
      await this.loadSession();
    } catch (e) {
      this.error = e.message || 'Unable to load fixture summary';
    } finally {
      this.loading = false;
    }
  },

  async loadFixture() {
    const res = await apiFetch(`/fixtures/${this.fixtureId}?populate=true`);
    const data = await res.json();
    if (!res.ok || !data?.ok) throw new Error(data?.message || 'Failed to load fixture');
    this.fixture = data.fixture;
  },

  async loadSession() {
    const res = await apiFetch(`/fixtures/${this.fixtureId}/session`);
    const data = await res.json();
    if (!res.ok || !data?.ok || !data?.session?._id) throw new Error(data?.message || 'No fixture session found');
    this.session = data.session;
  },

  teamName(side) {
    return side === 'home' ? (this.fixture?.homeTeamName || 'Home') : (this.fixture?.awayTeamName || 'Away');
  },

  formatDate(dt) {
    if (!dt) return 'TBC';
    const value = new Date(dt);
    return value.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
  },

  gameLegScore(game, side) {
    return (game?.legs || []).filter((leg) => leg.winnerSide === side).length;
  },

  gameWinnerLabel(game) {
    if (!game?.winnerSide) return 'In play';
    return this.teamName(game.winnerSide);
  },

  recentEvents() {
    return [...(this.session?.eventLog || [])].reverse();
  },

  printPage() {
    window.print();
  },

  close() {
    routerNavigate(`/admin/fixtures/${this.fixtureId}`);
  },
}));
